export default __webpack_public_path__ + "static/media/ic-holidays.2cb4e021.svg";